import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Injectable} from '@angular/core';

@Injectable()
export class ParksFetcher {
  constructor(private auth: AuthenticationService, private http: HttpClient) {
    //
  }

  private prepareParksUrl(page) {
    let userRole = '';

    switch (this.auth.userRole().toLowerCase()) {
      case 'employee':
        userRole = 'employees';
        break;
      case 'admin':
        userRole = 'admins';
        break;
      case 'manufacturer':
        userRole = 'manufacturers';
        break;
      case 'client':
        userRole = 'clients';
        break;
      default:
        throw new Error('Incorrect user role!');
    }

    return `/${userRole}/${this.auth.userId()}/parks?page=${page}&size=100`;
  }

  public retrieveParks() {
    return this.http.get(this.prepareParksUrl(1)).expand((prev: any) => {
      if (typeof prev.meta === 'undefined' || prev.meta.pagination.current_page >= prev.meta.pagination.last_page) {
        return Observable.empty();
      }

      const nextPage = prev.meta.pagination.current_page + 1;

      return this.http.get(this.prepareParksUrl(nextPage));
    }).scan((acc, r) => acc.concat(r.data), []).last();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/parks.fetcher.ts